module.exports = __webpack_public_path__ + "media/src/images/icons/close-3242cbbca5b98c656ddb9cdaca71f1b7.svg";